<template>
  <div>
    <form 
      ref="form" 
      @submit.prevent="checkForm"
    >
      <!-- 모달 컨텐츠 -->
      <div class="modal__contents">
        <div class="modal__middlebox">
          <div class="modal__row">
            <h2 class="subtitle subtitle--modal">
              예산 범위를 선택 해주세요
            </h2>
          </div>
          <div class="modal__row">
            <select 
              id="selectbudget" 
              v-model="req.budget"
              name="selectbudget" 
              class="budgetSelect"
            >
              <option 
                v-for="(budget, index) in budgetList"
                :key="index"
                class="budgetSelect__option" 
                :value="budget.value"
              >
                {{ budget.label }}
              </option>
            </select>
          </div>
        </div>
        <!-- <div class="modal__bottombox">
          <div class="checkbox">
            <input
              id="check"
              v-model="req.comment.tbd"
              class="checkbox__input"
              type="checkbox"
              name="check"
            >
            <label
              class="checkbox__label"
              for="check"
            >
              없습니다.
            </label>
          </div>
        </div> -->
      </div>
      <!-- 모달 푸터(bottom) -->
      <div class="modal__footer">
        <ul class="modal__buttons">
          <li class="modal__buttonitem">
            <button
              type="button"
              class="button button--large button--secondary"
              @click="save"
            >
              임시저장
            </button>
          </li>
          <li class="modal__buttonitem">
            <button
              type="submit"
              class="button button--large"
              :disabled="!req.budget"
              @click="$emit('next-step')"
            >
              다음
            </button>
            <!-- :disabled="!req.period.tbd && (!req.period.start || !req.period.end)" -->
          </li>
        </ul>
      </div>
      <!-- 모달 이전 -->
      <div class="modal__prevbutton">
        <button 
          class="button button--function" 
          @click="$emit('prev-step')"
        >
          이전
        </button>
      </div>
    </form>
  </div>
</template>
<script>
export default {
  name: "Budget",
  props: {
    request: {
      type: Object,
      required: true
    },
  },
  emits: ["prev-step", "save-click", "next-step"],
  data() {
    return {
      req: this.request,
      budgetList: [
        { label: '1,000만원 미만', value: '1,000만원 미만'},
        { label: '1,000만원 ~ 5,000만원', value: '1,000만원 ~ 5,000만원'},
        { label: '5,000만원 ~ 1억원', value: '5,000만원 ~ 1억원'},
        { label: '1억원 이상', value: '1억원 이상'}
      ]
    };
  },
  methods: {
    checkForm() {
      console.log(this.req);
      this.$emit("next-step");
    },
    save() {
      this.$emit("save-click");
    },
  }
};
</script>
<style lang="scss" scoped>
.modal {
  $self: &;
  &__buttons {
    width: 330px;
    margin: 0 auto;
    &:after {
      content: "";
      clear: both;
      display: inline;
    }
  }
  &__buttonitem {
    float: left;
    width: 160px;
    height: 50px;
    &:not(:first-child) {
      margin-left: 10px;
    }
  }
}
.formfield {
  $self: &;
  &__row {
    margin: 0 auto;
    width: 500px;
  }
  &__inputbox {
    height: 120px;
  }
  &__inputitem {
    width: 100%;
    text-align: left;
  }
}
</style>
